import React from 'react';
import { Field, RadioGroup } from '../../../Core';
import { ListFieldSection } from '../../../Layout';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown } from '../../Core';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let PreparationWetSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector = undefined }) => {
  const showGuardSieve = useSelector(
    pipe(createWorksheetSelector!('Preparation.GuardSieveUsed'), valueOrDefault(false))
  );

  const guardSieveSize = useSelector(createWorksheetSelector!('Preparation.GuardSieveSize'), deepEquals);
  const oversizeSieveSize = useSelector(createWorksheetSelector!('Preparation.OversizeSieveSize'), deepEquals);

  const materialRemovedByOptions = [
    {
      id: 'washing',
      label: `Washing over ${oversizeSieveSize.Caption} Sieve`,
      value: `Washing over ${oversizeSieveSize.Caption} sieve`,
    },
    {
      id: 'mechanical',
      label: `Mechanically pushed through ${oversizeSieveSize.Caption} sieve`,
      value: `Mechanically pushed through ${oversizeSieveSize.Caption} sieve`,
    },
    { id: 'hand', label: `Hand during mixing on glass plate`, value: `Hand during mixing on glass plate` },
  ];
  const selectedMaterialRemovedBy = useSelector(
    pipe(createWorksheetSelector!('Preparation.OversizeMaterialRemovedBy'), (materialRemovedBy) =>
      materialRemovedByOptions.find((o) => o.value === materialRemovedBy)
    )
  );

  return (
    <ListFieldSection heading="Wet Preparation">
      <Field
        input={<RadioGroup />}
        label="Oversize Material Removed By"
        name="Preparation.OversizeMaterialRemovedBy"
        options={materialRemovedByOptions}
      />
      <Field
        input={<RadioGroup />}
        label={`Coarser Sieve Used Over ${oversizeSieveSize.Caption} Sieve`}
        name="Preparation.GuardSieveUsed"
        visible={selectedMaterialRemovedBy?.id === 'washing'}
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />
      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Guard Sieve"
        equipmentType="sieve"
        name="Preparation.GuardSieve"
        visible={showGuardSieve && selectedMaterialRemovedBy?.id === 'washing'}
        queryParams={{ SieveSize: `${guardSieveSize?.Size.value} ${guardSieveSize?.Size.uom}` }}
      />
      <Field
        input={<WorksheetEquipmentDropdown />}
        label={`${oversizeSieveSize.Caption} Sieve`}
        equipmentType="sieve"
        name="Preparation.OversizeSieve"
        visible={selectedMaterialRemovedBy?.id !== 'hand'}
        queryParams={{ SieveSize: `${oversizeSieveSize?.Size.value} ${oversizeSieveSize?.Size.uom}` }}
      />
    </ListFieldSection>
  );
};

PreparationWetSection = withInjectedProps(PreparationWetSection);

export { PreparationWetSection };
export default PreparationWetSection;
